/** @jsx jsx */
import React from "react";
import { css, jsx } from "@emotion/react";
import PostCard from "../../common/PostCard";
import { withPrefix } from "gatsby-link";

const WrapInspoSection = ({data}) => {
    const finalData = data.slice(0, 30);
    return (
        <>
            <section
                css={css`
                    height: 110rem;
                    width: 100%;
                    background: linear-gradient(180deg, #FFDCF9 84.21%, #D9D9E3 100%);
                    padding: 0 4rem;
                    position: relative;
                    @media(max-width: 768px){
                        display: none;
                    }
                `}
            >
                <div css={css`
                    max-width: 120rem;
                    margin: auto;
                    position: relative;
                `}>

                <div css={css`
                    display: block;
                    border-radius: 2rem;
                    box-shadow: 1rem 1rem 0 #FD566F;
                    position: absolute;
                    min-height: 31rem;
                    max-width: 52rem;
                    z-index: 1;
                    padding: 4rem 3rem;
                    background: #fff;
                    left: 8rem;
                    top: 40rem;
                    @media(max-width: 768px){
                        left: 1rem;
                        top: 40rem;
                    }
                `}>
                    <h2 css={css`
                        color: #393972;
                        font-size: 4rem;
                        line-height: 5rem;
                    `}>
                        Looking for Inspiration?
                    </h2>
                    <p css={css`
                        color: #616161;
                        font-size: 1.6rem;
                        line-height: 2.2rem;
                        margin: 2rem auto;
                    `}>
                        Check out all of the wonderful packaging that has been made using the noissue platform. Use #noissuepackaging to be featured!
                    </p>
                    <a
                    css={css`
                        font-size: 1.6rem;
                        font-weight: 400;
                        line-height: 1.6;
                        padding: 1rem 4rem;
                        color: #FD566F;
                        border-radius: 1rem;
                        border: 0.2rem solid #FD566F;
                        cursor: pointer;
                        display: inline-block;
                        margin: 2rem auto;
                    `}
                    href={withPrefix("/inspo/")}
                >
                    Let’s Get Inspired
                </a>

                </div>
                <div css={css`
                    display: flex;
                    flex-direction: row;
                    width: 100%;
                    justify-content: center;
                `}>
                    <style jsx>{`
                        .wrap-card { 
                            display: flex;
                            flex-direction: column;
                            min-width: 30rem;
                            max-width: 30rem;
                            justify-content: center;        
                        }
                        @media(max-width: 1248px){
                            .hide-tablet-pro {
                                display: none;
                            }
                        }
                        @media(max-width: 768px){
                            .hide-tablet {
                                display: none;
                            }
                        }
                        `}
                    </style>
                    
                <div className="wrap-card">
                    {finalData.map((post,id)=>
                        <PostCard
                            id={id}
                            key={id}
                            post={post.node}
                            maxPosts={4}
                            posts = {data}
                        />
                    ).slice(1, 3)}
                </div>

                <div className="wrap-card hide-tablet">
                    {finalData.map((post,id)=>
                        <PostCard
                            id={id}
                            key={id}
                            post={post.node}
                            maxPosts={2}
                            posts = {data}
                        />
                    ).slice(3, 6)}
                </div>

                <div className="wrap-card hide-tablet-pro">
                    {finalData.map((post,id)=>
                        <PostCard
                            id={id}
                            key={id}
                            post={post.node}
                            maxPosts={2}
                            posts = {data}
                        />
                    ).slice(7, 9)}
                </div>

                <div className="wrap-card hide-tablet-pro">
                    {finalData.map((post,id)=>
                        <PostCard
                            id={id}
                            key={id}
                            post={post.node}
                            maxPosts={2}
                            posts = {data}
                        />
                    ).slice(10, 13)}
                </div>
                </div>
                </div>
            </section>
            {/* Tablet/Mobile View */}
            <section
                css={css`
                    display: none;
                    width: 100%;
                    background: linear-gradient(180deg, #FFDCF9 84.21%, #D9D9E3 100%);
                    position: relative;
                    @media(max-width: 768px){
                        display: block;
                    }
                `}
            >
                <div css={css`
                    padding: 4rem 2rem 0 2rem;
                    position: relative;
                    text-align: center;
                `}>
                    <h2 css={css`
                        color: #393972;
                        font-size: 4rem;
                        line-height: 5rem;
                        text-align: center;
                    `}>
                        Looking for Inspiration?
                    </h2>
                    <p css={css`
                        color: #616161;
                        font-size: 1.6rem;
                        line-height: 2.2rem;
                        margin: 2rem auto;
                        text-align: center;
                    `}>
                        Check out all of the wonderful packaging that has been made using the noissue platform. Use #noissuepackaging to be featured!
                    </p>
                    <a
                    css={css`
                        font-size: 1.6rem;
                        font-weight: 400;
                        line-height: 1.6;
                        padding: 1rem 4rem;
                        color: #FD566F;
                        border-radius: 1rem;
                        border: 0.2rem solid #FD566F;
                        cursor: pointer;
                        display: inline-block;
                        margin: 2rem auto;
                    `}
                    href={withPrefix("/inspo/")}
                >
                    Let’s Get Inspired
                </a>
                </div>
                <div>
                <style jsx>{`
                        .wrapcard {
                            height: 25rem;
                            min-width: 18rem;
                            max-width: 18rem;
                        }
                    `}
                    </style>
                <div css={css`
                    display: flex;
                    flex-direction: row;
                    justify-content: start;
                    margin-top: 5rem;
                    max-width: 120rem;
                    padding: 2rem 0;
                    margin: auto;
                    overflow-y: auto;
                `}>
                    {finalData.map((post,id)=>
                        <div className='wrapcard'>
                            <PostCard
                                id={id}
                                key={id}
                                post={post.node}
                                maxPosts={4}
                                posts = {data}
                            />
                        </div>
                    ).slice(5, 12)}
                </div>
                <div css={css`
                    display: flex;
                    flex-direction: row;
                    justify-content: start;
                    margin-top: 5rem;
                    max-width: 120rem;
                    padding: 2rem 0;
                    margin: auto;
                    overflow-y: auto;
                `}>
                    {finalData.map((post,id)=>
                        <div className='wrapcard'>
                            <PostCard
                                id={id}
                                key={id}
                                post={post.node}
                                maxPosts={4}
                                posts = {data}
                            />
                        </div>
                    ).slice(13, 17)}
                </div>
                </div>
            </section>

            </>
    );
};

export default WrapInspoSection;
